import { localeConfig } from '@/locale'
import moment from 'moment-timezone'

export const formatTimestamp = (
  timestamp: string | number = '',
  timezone: string = '',
  formatType: string = 'DD MMM YYYY HH:mm',
) => {
  let finalTimezone: string = timezone
  if (!timezone) {
    finalTimezone = localeConfig.defaultTimezone
  }

  const timestampNumber = Number(timestamp)
  if (timestampNumber < 1e10) {
    return moment.unix(timestampNumber).tz(finalTimezone).format(formatType)
  }

  return moment(timestampNumber).tz(finalTimezone).format(formatType)
}

export function formatTimestampToMs(timestamp?: string | number) {
  if (!timestamp) {
    return (timestamp ?? '')?.toString()
  }

  return (Number(timestamp) * 1000).toString()
}

export function formatTimestampToSec(timestamp?: string | number) {
  if (!timestamp) {
    return undefined
  }

  return Math.floor(Number(timestamp) / 1000)
}
